import type { SxProps, Theme } from "@mui/material";

export const deliveryPeopleInfoIconSx: SxProps<Theme> = {
  color: "#000000",
  p: 0.25,
  "&:hover": {
    color: "#000000",
    backgroundColor: "action.hover",
  },
};

export function getDeliveryPeoplePriorityTooltipComponentsProps() {
  return {
    tooltip: {
      sx: {
        bgcolor: "#000000",
        color: "#FFFFFF",
        whiteSpace: "pre-line",
        maxWidth: 320,
        typography: "caption",
      },
    },
  };
}

export const selectDeliveryEditButtonSx: SxProps<Theme> = {
  width: "250px",
};

export const mapAreaViewEditButtonSx: SxProps<Theme> = {
  width: "100%",
};

export const deliveryInfoIconInnerSx: SxProps<Theme> = {
  fontSize: 20,
  color: "#000000",
};

export const deliveryListShippingIconSx: SxProps<Theme> = {
  fontSize: 20,
  color: "text.secondary",
};
